<template src="./RegisterPlanPackage.html"></template>

<script>
import mixins from "../../../../../Mixins.js";
export default {
  name: "registerPlanPackage",
  mixins: [mixins],
  data() {
    return { 
      planPackages: [],
      planPackagesFiltered: [],
      packageName: "",
      packageStatus: true,
      packageId: null,
      defaultTableText: "Aguarde, estamos carregando as informações...",
      packageFilter: "",
      enablePagination: true,
      windowWidth: 0,
      numPages: 1,
      currentx: 1,
      pagination: false,
      modalTitle: "",
      disableModalEdit: false,
      invalidPackageName: false,
    };
  },
  mounted: function() {
    this.init()
  },
  created() {
    window.addEventListener("resize", this.handleResize)
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize)
  },
  watch: {
    packageFilter: function (string) {
      if (string === "") {
        this.enablePagination = true
        this.changePagination()
      }
      else {
        this.enablePagination = false
        this.planPackagesFiltered = this.planPackages.filter( 
            pckg => (pckg.name.toLowerCase().includes(string.toLowerCase()))
        ) 
      }
    },
    currentx: function () {
      this.changePagination();
    },
  },
  methods: {
    init() {
      this.getPlanPackages()
    },
    getPlanPackages() {
      this.axios.get(`${this.$store.state.filooServer}plan-package`, 
        { headers: { Authorization: this.$session.get("bearerDefault") }, } )
        .then( res => {
          this.defaultTableText = "Nenhum resultado encontrado"
          if (res.data.length > 0) {
            this.planPackages = res.data
            this.planPackagesFiltered = res.data
            this.numPages = Math.ceil(this.planPackagesFiltered.length / 10)
            this.pagination = this.numPages > 1
            this.changePagination()
          }
        })
        .catch( err => {
          this.defaultTableText = "Nenhum resultado encontrado"
          console.log({
            endpointURL: "plan-package",
            error_getPlanPackages: err,
          })
          this.showNotifyWarning(
            "Ocorreu um erro ao buscar a lista de pacote de planos. Por favor, tente novamente mais tarde!", 
            5000,
          )
        })
    },
    editPlan(tr) {
      this.packageName = ""
      this.packageStatus = false
      this.packageId = tr.id
      this.modalTitle = "Editar pacote"
      this.disableModalEdit = true
      this.$bvModal.show("modal-register-new-package")
      this.axios.get(`${this.$store.state.filooServer}plan-package/${tr.id}`, 
        { headers: { Authorization: this.$session.get("bearerDefault") }, } )
        .then( res => {
          this.packageName = res.data.name
          this.packageStatus = res.data.active
          this.disableModalEdit = false
        })
        .catch( err => {
          console.log({
            endpointURL: `plan-package/${tr.id}`,
            error_handleSelected: err,
          })
          this.showNotifyWarning(
            "Ocorreu um erro ao tentar selecionar o pacote de planos. Por favor, tente novamente mais tarde!", 
            5000,
          )
        })
    },
    updatePlanPackages() {
      if (this.packageName !== "") {
        const method = this.packageId ? "put" : "post"
        const URLSuffix = method === "put" ? `/${this.packageId}` : "" 
        this.axios({
          method,
          url: `${this.$store.state.filooServer}plan-package${URLSuffix}`,
          data: {
            name: this.packageName,
            active: this.packageStatus
          }
        })
        .then(() => {
          this.$bvModal.hide("modal-register-new-package")
          const messagem = method === "post" ? 
            "Pacote de planos adicionado com sucesso!" : 
            "Pacote de planos atualizado com sucesso!"
          this.showNotifySuccess(
            "Sucesso", 
            messagem, 
            5000,
          )
          this.getPlanPackages()
        })
        .catch( err => {
          console.log({
            endpointURL: `plan-package${URLSuffix}`,
            error_updatePlanPackages: err,
          })
          this.$bvModal.hide("modal-register-new-package")
          this.showNotifyWarning(
            "Não foi possível realizar a transação. Por favor, tente novamente mais tarde!", 
            5000,
          )
        })
      } else this.invalidPackageName = true
    },
    changePagination() {
      const firstElement = (this.currentx - 1) * 10
      const lastElement = firstElement + 10
      this.planPackagesFiltered = this.planPackages.slice(firstElement , lastElement)
    },
    handleNewPackage() {
      this.packageName = ""
      this.packageId = null
      this.modalTitle = "Novo pacote"
      this.$bvModal.show("modal-register-new-package")
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
}
</script>

<style lang="scss" src="./RegisterPlanPackage.scss">
</style>